<ul style="margin:0;padding:0;list-style:none;">
    <li>
        <a id="terms-of-use"
           appTrackClickButton
           class="dropdown-item" href="https://er45.deloitteonline.com/dol/dol_DisplayContent.aspx?Type=4"
           target="_blank"
           (click)="dropdown.hide()"
        >
            <i class="icon-full-file"></i>
            Terms of Use
        </a>
    </li>
    <li>
        <a id="privacy-policy"
           appTrackClickButton
           class="dropdown-item"
           href="https://www2.deloitte.com/us/en/footerlinks1/privacy.html?icid=bottom_privacy"
           target="_blank"
           (click)="dropdown.hide()"
        >
            <i class="icon-security-shield"></i>
            Privacy Policy
        </a>
    </li>
    <li>
        <a id="cookie-notice"
           appTrackClickButton
           class="dropdown-item"
           href="https://cookienotice.deloitte.com"
           target="_blank"
           (click)="dropdown.hide()"
        >
            <img [src]="iconCookie" alt="icon-cookie">
            Cookies
        </a>
    </li>
    <li>
        <button type="button"
           id="cookie-settings"
           appTrackClickButton
           class="dropdown-item"
           (click)="openCookieSettings(); dropdown.hide()"
        >
            <img [src]="iconCookie" alt="icon-cookie">
            Cookie Settings
        </button>
    </li>
</ul>
